import './publicPath'; // FIRST: sets the chunk base URL for /r/{appId} hosts
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { fetchRemoteConfig } from './config/fetchRemoteConfig';
import { getRemoteEnv } from './config/remoteEnv';
import { initializeFirebase, FIREBASE_AUTH } from './Firebase';

const sleep = (ms: number) => new Promise<void>((r) => setTimeout(r, ms));

const startApp = async () => {
  // Transient network flakes on first load (fresh devices, demo wifi)
  // shouldn't dead-end the boot — retry with backoff before giving up.
  let booted = false;
  let lastErr: unknown = null;
  for (const delay of [0, 800, 2000]) {
    if (delay) await sleep(delay);
    try {
      await fetchRemoteConfig();
      console.log("[Startup] Remote config loaded");

      const env = getRemoteEnv();
      await initializeFirebase(env.firebaseConfig, env.appId);
      console.log("[Startup] Firebase initialized, FIREBASE_AUTH:", !!FIREBASE_AUTH);
      booted = true;
      break;
    } catch (err) {
      lastErr = err;
      console.warn("[Startup] Init attempt failed, will retry:", err);
    }
  }

  if (!booted) {
    console.error("[Startup] Failed to initialize app:", lastErr);
    document.getElementById('root')!.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;height:100vh;background:#0b0b0d;color:#f0f0f0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;padding:24px;box-sizing:border-box;">
        <div style="text-align:center">
          <div style="font-size:40px;margin-bottom:14px;">&#128246;</div>
          <h2 style="margin:0 0 8px;font-size:20px;">Couldn't reach the restaurant</h2>
          <p style="color:#888;margin:0 0 20px;font-size:14px;">Check your connection and try again &mdash; it usually comes right back.</p>
          <button onclick="window.location.reload()" style="padding:12px 28px;border-radius:12px;border:none;background:#4169E1;color:#fff;font-size:15px;font-weight:700;cursor:pointer;">Try again</button>
        </div>
      </div>
    `;
    return;
  }

  ReactDOM.render(
    <App />,
    document.getElementById('root')
  );
};

startApp();
reportWebVitals();